import * as getters from "../../baseQuestion/date/store/getters";
import * as mutations from "../../baseQuestion/date/store/mutations";
import * as actions from "../../baseQuestion/date/store/actions";
import { state as date_state } from "../../baseQuestion/date/store/state";

function state() {
	return date_state();
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
